import React, { useState, useEffect, useContext } from "react";
import shortid from "shortid";

import { LOAD_POST_OFFER_SEND_URL } from "../../../../utils/api-ends";
import useHttp from "../../../../hooks/useHttp";
import LoaderImg from "../../../../assets/media/loader.gif";
import { ManageLoadPostDetailPageContext } from "../";
import Alert from "@mui/material/Alert";

const SendOffer = ({ loadPostId }) => {
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [pickupDateTime, setPickupDateTime] = useState("");
  const [estimatedDeliveryDuration, setEstimatedDeliveryDuration] =
    useState("");
  const [loadPostDetailState, loadPostDetailContextDispatch] = useContext(
    ManageLoadPostDetailPageContext
  );

  // Set offer current amount by click offer button beside of the load post default amount
  useEffect(() => {
    if (loadPostDetailState.offerCurrentAmount) {
      setAmount(loadPostDetailState.offerCurrentAmount);
    }
  }, [loadPostDetailState.offerCurrentAmount]);

  const [amountErr, setAmountErr] = useState([]);
  const [descriptionErr, setDescriptionErr] = useState([]);
  const [pickupDateTimeErr, setPickupDateTimeErr] = useState([]);
  const [estimatedDeliveryDurationErr, setEstimatedDeliveryDurationErr] =
    useState([]);
  const [commonErr, setCommonErr] = useState([]);

  const { isLoading, error, sendRequests: SendOffer } = useHttp();

  const onVehicleChange = (e) => setAmount(e.target.value);
  const onDescriptionChange = (e) => setDescription(e.target.value);
  const onPickupDateTimeChange = (e) => setPickupDateTime(e.target.value);
  const onEstimatedDeliveryDurationChange = (e) =>
    setEstimatedDeliveryDuration(e.target.value);

  const handleSubmit = () => {
    // Clear error messages
    setAmountErr([]);
    setDescriptionErr([]);
    setPickupDateTimeErr([]);
    setEstimatedDeliveryDurationErr([]);
    setCommonErr([]);

    // Some of field is required
    if (amount?.length === 0) setAmountErr(["This field is required."]);
    if (description?.length === 0)
      setDescriptionErr(["This field is required."]);
    if (pickupDateTime?.length === 0)
      setPickupDateTimeErr(["This field is required."]);
    if (estimatedDeliveryDuration?.length === 0)
      setEstimatedDeliveryDurationErr(["This field is required."]);

    // If has error stuck here
    if (
      amount?.length === 0 ||
      description?.length === 0 ||
      pickupDateTime?.length === 0 ||
      estimatedDeliveryDuration?.length === 0
    ) {
      return;
    }

    const response = (data) => {
      loadPostDetailContextDispatch({
        type: "CARRIER_SEND_OFFER_SUCCESSFULLY",
        payload: data,
      });
      window.scrollTo(0, 0);
    };

    SendOffer(
      {
        url: LOAD_POST_OFFER_SEND_URL,
        method: "post",
        data: {
          amount,
          description,
          load_post_obj: loadPostId,
          estimated_delivery_time: estimatedDeliveryDuration,
          pickup_time: pickupDateTime,
        },
      },
      response
    );
  };

  // Catch server error
  useEffect(() => {
    if (error?.description) setDescriptionErr(error.description);
    if (error?.amount) setAmountErr(error.amount);
    if (error?.pickup_time) setPickupDateTimeErr(error.pickup_time);
    if (error?.estimated_delivery_time)
      setEstimatedDeliveryDurationErr(error.estimated_delivery_time);
    if(error?.general) setCommonErr(error.general)
  }, [error]);

  // Show or hide error messages on mouse enter or leave
  const showErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "true");
  const hideErrorMessage = (e) =>
    e.currentTarget.setAttribute("show-tittle", "false");

  return (
    <section id="offer-send-box">
      <div className="container theme-section">
        <p className="mb-4">
          *** Send You Offer By fill Up The Form And Wait For The Shipper
          Response
        </p>

        {commonErr?.length > 0 && (
          <div className="auth-error withdraw-message-style mb-4">
            <Alert className="withdraw-alert-message" severity="info">
              {commonErr}
            </Alert>
          </div>
        )}

        <div className="row">
          <div className="col-md-6">
            <div className="input-box-area" single-labe="true">
              <label> Counter Amount </label>
              <input
                type="number"
                placeholder="Amount"
                value={amount}
                onChange={onVehicleChange}
                min="0"
              />

              {amountErr?.map((err) => (
                <div
                  key={shortid.generate()}
                  className="error"
                  show-tittle="false"
                  onMouseEnter={showErrorMessage}
                  onMouseLeave={hideErrorMessage}
                >
                  <i className="fa-solid fa-circle-exclamation"></i>
                  <p>{err}</p>
                </div>
              ))}
            </div>

            <div className="input-box-area" single-labe="true">
              <label> Pickup Datetime </label>
              <input
                type="datetime-local"
                placeholder="Pickup Datetime"
                value={pickupDateTime}
                onChange={onPickupDateTimeChange}
              />
              {pickupDateTimeErr?.map((err) => (
                <div
                  key={shortid.generate()}
                  className="error"
                  show-tittle="false"
                  onMouseEnter={showErrorMessage}
                  onMouseLeave={hideErrorMessage}
                >
                  <i className="fa-solid fa-circle-exclamation"></i>
                  <p>{err}</p>
                </div>
              ))}
            </div>

            <div className="input-box-area" single-labe="true">
              <label> Estimated Delivery time </label>
              <input
                type="datetime-local"
                placeholder="Estimated Delivery Datetime"
                value={estimatedDeliveryDuration}
                onChange={onEstimatedDeliveryDurationChange}
              />
              {estimatedDeliveryDurationErr?.map((err) => (
                <div
                  key={shortid.generate()}
                  className="error"
                  show-tittle="false"
                  onMouseEnter={showErrorMessage}
                  onMouseLeave={hideErrorMessage}
                >
                  <i className="fa-solid fa-circle-exclamation"></i>
                  <p>{err}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-6">
            <div className="input-box-area" single-labe="true">
              <label> Description </label>
              <textarea
                placeholder="Description "
                value={description}
                onChange={onDescriptionChange}
              ></textarea>
              {descriptionErr?.map((err) => (
                <div
                  key={shortid.generate()}
                  className="error"
                  show-tittle="false"
                  onMouseEnter={showErrorMessage}
                  onMouseLeave={hideErrorMessage}
                >
                  <i className="fa-solid fa-circle-exclamation"></i>
                  <p>{err}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="multiple-btn">
          <button onClick={handleSubmit}>
            Offer
            {isLoading && (
              <img style={{ width: "22px" }} src={LoaderImg} alt="" />
            )}
          </button>
        </div>
      </div>
    </section>
  );
};

export default React.memo(SendOffer);
